import * as React from "react";

const Find = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer11"
      fill="none"
      fillOpacity="1"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="miter"
      strokeOpacity="1"
      strokeWidth="0.4"
    >
      <circle
        id="path43"
        cx="2.515"
        cy="2.514"
        r="1.985"
        strokeDasharray="none"
        strokeDashoffset="3.477"
        opacity="1"
      ></circle>
      <path
        id="path44"
        strokeDasharray="1.6, 0.6"
        strokeDashoffset="1.12"
        d="m3.969 3.969.417.417.773.773.331.331.33.33"
        opacity="1"
      ></path>
      <path
        id="path45"
        strokeDasharray="none"
        strokeDashoffset="3.477"
        d="M2.875 3.65a1.19 1.19 0 0 1-1.471-.704"
        opacity="1"
      ></path>
    </g>
  </svg>
);

export default Find;
